import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsDelivery = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
 
      <g fill="currentColor">
	<rect x="2.3872933" y="9.9284182" width="6.0786042" height="1.305917"/>
	<rect x="1.0236744" y="8.1608334" width="6.0785832" height="1.305917"/>
	<rect x="1.0236744" y="11.7152367" width="6.0785832" height="1.3059065"/>
	<path d="M22.5989132,11.5012627l-3.1037979-3.383812c-0.2736168-0.2970676-0.6602154-0.4674392-1.0606747-0.4674392H15.863224
		V6.504395c0-0.7917237-0.6448965-1.4379563-1.438426-1.4405651H4.0822001c-0.7943225,0-1.4405549,0.6462321-1.4405549,1.4405651
		v1.2781358H3.906934V6.504395c0-0.0966396,0.0786264-0.1752558,0.175266-0.1752558h10.3447266
		c0.0966396,0,0.1752663,0.0786161,0.1752663,0.1752558v9.0494976c0,0.0966396-0.0786266,0.1752653-0.1752663,0.1752653h-3.4893122
		c-0.1318092-0.5200787-0.423419-0.9883938-0.8355665-1.3358164c-0.4634933-0.3907118-1.0508451-0.6058855-1.6538296-0.6058855
		c-0.1394901,0-0.2805462,0.0115423-0.4190979,0.0342722c-1.0184512,0.1664162-1.8293672,0.920455-2.0779791,1.9074297H4.080071
		c-0.0966394,0-0.175266-0.0786257-0.175266-0.1752653v-2.0903149H2.6394954v2.0903149
		c0,0.7943439,0.6462324,1.4405746,1.4405756,1.4405746h1.8713417c0.1318097,0.5200806,0.423419,0.9883957,0.8355665,1.3358173
		c0.4634938,0.3907127,1.0508451,0.6058865,1.6538501,0.6058865c0.1394911,0,0.2805471-0.0115433,0.4190989-0.0342731
		c1.0184298-0.1664162,1.8293457-0.920454,2.0779581-1.9074306h5.3582525
		c0.1318111,0.5200806,0.42342,0.9883957,0.8355675,1.3358173c0.4634933,0.3907127,1.0508442,0.6058865,1.6538506,0.6058865
		c0.1394901,0,0.2805462-0.0115433,0.4190979-0.0342731c1.0184307-0.1664162,1.8293457-0.920454,2.0779591-1.9074306h0.2531204
		c0.7943211,0,1.4405537-0.6462307,1.4405537-1.4405746v-3.078042
		C22.9788971,12.1142559,22.8447285,11.7679815,22.5989132,11.5012627z M20.4467964,14.3954697
		c-0.4634933-0.3907108-1.0508461-0.6058855-1.6538296-0.6058855c-0.1395111,0-0.2805672,0.0115423-0.4191189,0.0342932
		c-1.0184517,0.1664162-1.8293686,0.920455-2.07798,1.9074306h-0.4392185
		c0.0072002-0.0583391,0.0108538-0.1169901,0.0108538-0.1752663V8.9153214h2.5626574
		c0.0475903,0,0.0935726,0.0206528,0.1273651,0.0579939l2.3455639,2.5559692h-2.5990181
		c-0.0966396,0-0.1752663-0.0786161-0.1752663-0.1752558V9.5843048h-1.2653103v1.7697239
		c0,0.7943325,0.6462326,1.4405651,1.4405766,1.4405651h3.406908v2.7614479c0,0.0966396-0.0786057,0.1752663-0.1752453,0.1752663
		H21.282341C21.1505318,15.2112284,20.8589439,14.7428923,20.4467964,14.3954697z M17.479044,16.3688774
		c0.0017967-0.7216234,0.588583-1.3087025,1.3080578-1.3087025c0.7212677,0,1.3080559,0.5867872,1.3080559,1.3080559
		c0,0.7212696-0.5867882,1.3080559-1.3080559,1.3080559C18.0658321,17.6762867,17.479044,17.0895004,17.479044,16.3688774z
		 M7.1321888,16.3618031c0-0.7210817,0.5864744-1.307744,1.3074932-1.3080368
		c0.7197657,0.0018368,1.3068247,0.5888958,1.3086195,1.3080368c0,0.7212677-0.5867872,1.3080559-1.3080559,1.3080559
		S7.1321888,17.0830708,7.1321888,16.3618031z"/>
</g>
    </SvgIcon>
  );
});

export default AppIconsDelivery;
